<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crt"><a class="page" id="piv"></a>NEW YORK UNIVERSITY PRESS</p>
<p class="crt">New York</p>
<p class="crt"><a class="url" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="crtf">© 2018 by New York University</p>
<p class="crt">All rights reserved</p>
<p class="crtf">References to Internet websites (URLs) were accurate at the time of writing. Neither the author nor New York University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Names: Greenspahn, Frederick E., 1946– editor.</p>
<p class="cip">Title: Early Judaism : new insights and scholarship / edited by Frederick E. Greenspahn.</p>
<p class="cip">Description: New York : New York University Press, 2018. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2017037989 | ISBN 978-1-4798-9695-0 (cl : alk. paper) | ISBN 978-1-4798-0990-5 (pb : alk. paper)</p>
<p class="cip">Subjects: LCSH: Judaism—History—Post-exilic period, 586 B<span class="sm">.</span>C<span class="sm">.</span>–210 A<span class="sm">.</span>D.</p>
<p class="cip">Classification: LCC BM176 .E27 2018 | DDC 296.09/014—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2017037989" target="_blank">https://lccn.loc.gov/2017037989</a></p>
<p class="crtf">New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.</p>
<p class="crtf">Manufactured in the United States of America</p>
<p class="crtf">10 9 8 7 6 5 4 3 2 1</p>
<p class="crtf">Also available as an ebook</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// greenspahnEarly-0005.vue?0ef2e8f6